module.exports = __webpack_public_path__ + "01a59fa53a91d49e1cc4b2be1c9062ca.png";